



































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class Selector extends Vue {
  status: string;

  @Prop({ default: false })
  indeterminate: boolean;

  @Prop({ default: false })
  value: boolean;

  @Prop({ default: false })
  disabled: boolean;

  @Watch("value")
  onValueChanged(v: any) {
    if (this.indeterminate) {
      this.status = "INDETERMINATE";
    } else {
      if (v) {
        this.status = "SELECTED";
      } else {
        this.status = "";
      }
    }
  }

  constructor() {
    super();
    this.status = "";
  }

  clickHandler($event: Event) {
    $event.stopPropagation();
    let newValue = false;
    if (this.status === "SELECTED") {
      this.status = "";
      newValue = false;
    } else {
      this.status = "SELECTED";
      newValue = true;
    }
    this.$emit("valuechanged", newValue);
  }

  created() {
    if (this.indeterminate) {
      this.status = "INDETERMINATE";
    } else {
      if (this.value) {
        this.status = "SELECTED";
      } else {
        this.status = "";
      }
    }
  }
}
